import { AfterViewInit, Component, inject, OnInit, TemplateRef, viewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { forkJoin, Observable } from 'rxjs';
import { take } from 'rxjs/operators';

import { OcJsonSchemaValidatorAjv } from '../../../core/oc-validator/oc-jsonSchemaValidatorAjv.service';
import { NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

import { IError } from '@orgacard/login';

import { AppService } from '../../../app.service';
import { CoreService } from '../../../core/core.service';
import { EnvironmentService } from '../../../core/environment.service';
import { ocValidator } from '../../../core/oc-validator/oc.validator';
import { ImageService } from '../../../core/services/image.service';
import { ModalService } from '../../../core/services/modal.service';
import { UtilityHelperService } from '../../../core/utility-helper.service';
import { UtilityHelper } from '../../../core/utility.helper';
import { LoadingOverlayService } from '../../../loading-overlay/loading-overlay.service';
import { CostcentertreeService } from '../../shared/costcentertree/costcentertree.service';
import { ICardDescription, ICostcenter, LockedType, StateEnum } from '../../shared/models/basic.model';
import { OffcanvasComponent } from '../../shared/offcanvas/offcanvas.component';
import { EdiService } from '../../shared/services/edi.service';
import { IButtonTitelbarCard } from '../../shared/title-bar/models/IButtonTitelbarCard';
import {
    ISupplierContact,
    ISupplierContract,
    ISupplierContractCostcenterCustomer,
    ISupplierCustomerDetails,
    ISupplierStatus,
    SupplierContractFilter,
} from '../shared/models/supplier.model';
import { SupplierService } from '../shared/services/supplier.service';

@UntilDestroy()
@Component({
    selector: 'app-supplier',
    templateUrl: './detail.component.html',
    styleUrls: ['./detail.component.scss'],
    standalone: false,
})
export class DetailComponent implements AfterViewInit, OnInit {
    private readonly utilityHelperService = inject(UtilityHelperService);
    private modalService = inject(ModalService);
    environmentService = inject(EnvironmentService);
    private route = inject(ActivatedRoute);
    private formBuilder = inject(UntypedFormBuilder);
    ocJsonSchemaValidatorAjv = inject(OcJsonSchemaValidatorAjv);
    supplierService = inject(SupplierService);
    coreService = inject(CoreService);
    private appService = inject(AppService);
    costcentertreeService = inject(CostcentertreeService);
    private router = inject(Router);
    imageService = inject(ImageService);
    loadingOverlayService = inject(LoadingOverlayService);

    // @ViewChild('costCenterModalBasic', {static: false}) costCenterModalBasic: TemplateRef<any>;
    // @ViewChild('newSupplierModal', {static: false}) newSupplierModal: TemplateRef<any>;
    public readonly createStepsModal = viewChild<TemplateRef<any>>('createStepsModal');
    public readonly offcanvas = viewChild(OffcanvasComponent);

    public utilityHelper = new UtilityHelper(this.appService, this.environmentService, this.coreService, this.loadingOverlayService);

    public basedataForm: UntypedFormGroup;
    // convenience getter for easy access to form fields
    public get basedataf() {
        return this.basedataForm.controls;
    }

    public stateEnum = StateEnum;
    public costcenterModalHeadline: string = this.coreService.getMsgkey('mws.costcenterregister', undefined);
    public actionNewCostcenterId: number;

    // CONTRACT
    public displayedContractColumns = ['costcenter', 'contractNumber', 'dateFrom', 'dateTill'];
    // CUSTOMERS     'isFavorite',
    public displayedCustomerColumns = ['costcenter', 'customerName'];

    public showPassDiv: boolean = true;

    public step: number = 1;

    public titleButtons: IButtonTitelbarCard[] = [];
    public supplierName: string = '';
    public supplierCarddescription: ICardDescription[];
    public supplierContacts: ISupplierContact[];
    public supplierContractCostcenterCustomers: ISupplierContractCostcenterCustomer[];
    public supplierContractCostcenterStatus: ISupplierStatus = undefined;
    public actualCostcenterInfo: string;
    public actualSupplierContractCostcenterCustomer: ISupplierContractCostcenterCustomer;
    public isCustomerSelected: boolean = false;

    public myCostcenterCustomerList: {
        costcenterId: number;
        costcenterNumber: string;
        costcenterDescription: string;
        customerId: number;
        customerName: string;
        customerNumber: string;
        supplierContractCostcenterCustomer: ISupplierContractCostcenterCustomer;
    }[] = [];
    public myDisplayedCostcenterCustomerListColumns = ['costcenterNumber', 'customerName', 'supplierContractCostcenterStatus'];

    public isContractStatusValid: boolean = false;
    public isSupplierLoaded: boolean = false;

    public get imagePath() {
        return this.imageService.getImageUrl({
            imageId: this.supplierService.supplierBasedata?.imageId ?? null,
        });
    }

    public ngOnInit() {
        if (
            this.environmentService.userCostcenter &&
            this.environmentService.userCostcenter.usercostcenters &&
            this.environmentService.userCostcenter.usercostcenters.length > 0
        ) {
            if (this.route.snapshot.paramMap.keys && this.route.snapshot.paramMap.keys.length > 0) {
                this.supplierService.method = this.route.snapshot.paramMap.get('method');
                // this.setTitleButtons('PASS');
                this.supplierService.supplierId = +this.route.snapshot.paramMap.get('supplierId');
                this.supplierService.supplierCostcenterId = +this.route.snapshot.paramMap.get('costcenterId');
            }
            this.init();
        } else {
            this.appService.showToast(
                'error',
                this.coreService.getMsgkey('prompt.error', []) + ': NO_USER_COSTCENTER',
                this.coreService.getMsgkey('prompt.error.configuration.nousercostcenter', []),
            );
            this.router.navigate(['mwsp/supplier/overview']);
        }
    }

    public ngAfterViewInit() {
        // Try using ngAfterViewInit instead of ngOnInit. ngOnInit runs before child components are ready.
        // console.log('************* detail.component - ngAfterViewInit *************');
        if (this.supplierService.method === 'NEW') {
            // this.openCostcentertreebasicModal();
            // this.costcentertreeService.getCostcenterNodes().subscribe(response => {
            //     this.openCostcenterModal();
            // });

            this.costcentertreeService
                .getCostcenterTreeByTreeNode(this.environmentService.currentUserCostcenterId)
                .pipe(take(1))
                .subscribe(
                    (costcenters) => {
                        // this.openCostcenterModal();
                        this.openCreateStepsModal();
                    },
                    (err: IError) => {
                        this.utilityHelperService.handleComponentError(err);
                    },
                );
            // NICHT HIER MACHEN wg. NgViewAfterInit ERROR
            // this.supplierService.initSupplierBasedata();
        } else if (this.supplierService.method === 'EDIT' && this.supplierService.supplierId) {
            // NICHT HIER MACHEN wg. NgViewAfterInit ERROR
            // this.initActiveSupplier();
        } else {
            // TODO: Fehler
        }
    }

    public init() {
        this.isSupplierLoaded = false;
        this.supplierService.supplierContract = undefined;
        this.supplierService.supplierCurrentCustomer = undefined;
        this.myCostcenterCustomerList = [];
        if (this.supplierService.method === 'NEW') {
            this.initFormValues();
        }
        // ggf. Werte aktualisieren !
        const observableBatch: Observable<unknown>[] = [];
        observableBatch.push(this.coreService.getContactTypes());
        observableBatch.push(this.coreService.getAddressTypes());
        // observableBatch.push(this.coreService.getHolidays()); // SRk 2026-02: herausgenommen wird hier nicht gebraucht und verursacht nur unnötige Ladezeit!
        observableBatch.push(this.coreService.getCurrencies());
        observableBatch.push(this.coreService.getCountries(LockedType.NOTLOCKED));

        forkJoin(observableBatch)
            .pipe(untilDestroyed(this))
            .subscribe({
                next: (results) => {
                    //
                    if (this.supplierService.method === 'NEW') {
                        this.supplierService.init();
                    } else if (this.supplierService.method === 'EDIT' && this.supplierService.supplierId) {
                        this.initActiveSupplier();
                    } else {
                        this.appService.showToast('error', '', 'SupplierID not found');
                        this.router.navigate(['mwsp/supplier/overview']);
                    }
                },
                error: (err: IError) => {
                    this.utilityHelperService.handleComponentError(err);
                },
            });
    }

    public initActiveSupplier() {
        this.loadingOverlayService.startLoading();
        // INIT DATA
        this.supplierService.init();
        this.myCostcenterCustomerList = [];
        //
        const observableBatch = [];
        observableBatch.push(this.supplierService.getSupplierBasedata());
        observableBatch.push(this.supplierService.getContractsBySupplierId(this.supplierService.supplierId, SupplierContractFilter.VALID));
        // observableBatch.push(this.supplierService.getCustomersBySupplierId());
        observableBatch.push(this.supplierService.getCertifications());
        observableBatch.push(this.supplierService.getSupplierCertification());
        forkJoin(observableBatch)
            .pipe(take(1))
            .subscribe({
                next: (results) => {
                    if (this.environmentService.appSettings.showLog) console.log(new Date() + ': ' + 'detail.component.ts - forkJoin RESULT ');
                    this.supplierName = this.supplierService.supplierBasedata.name;
                    this.supplierCarddescription = this.supplierService.supplierBasedata._cardDescriptions;
                    this.supplierContacts = this.supplierService.supplierBasedata.supplierContacts;
                    this.supplierService.supplierBasedataStateHash = this.utilityHelper.groupStatusMessages(
                        this.supplierService.supplierBasedata.supplierStatus,
                    );
                    this.loadingOverlayService.stopLoading();
                    this.isSupplierLoaded = true;

                    this.setTitleButtons('PASS');
                },
                error: (err: IError) => {
                    console.log('ERROR detail.component: ' + err);
                    this.utilityHelperService.handleComponentError(err);
                },
            });
    }

    public setTitleButtons(action: string) {
        this.titleButtons = [];
        if (action === 'PASS') {
            this.titleButtons.push({
                iconname: 'circle-filled-left',
                function: 'backToOverview',
                styleclass: 'btn-primary',
                tooltip: this.coreService.getMsgkey('mws.back', undefined),
            });
            if (this.coreService.checkAbility('execute', 'supplier.edit')) {
                this.titleButtons.push({
                    iconname: 'general-edit',
                    function: 'toggleEdit',
                    styleclass: 'btn-primary',
                    tooltip: this.coreService.getMsgkey('mws.edit', undefined),
                });
            }
            // if (this.coreService.checkAbility('execute', 'supplier.statistics')) {
            //     this.titleButtons.push(
            //         {
            //             iconname: 'statistics',
            //             function: 'showStatistics',
            //             styleclass: 'btn-primary',
            //             tooltip: this.coreService.getMsgkey("mws.showstatistics", undefined)
            //         }
            //     )
            // }
            if (
                this.coreService.checkAbility('execute', 'supplier.archive') &&
                this.supplierService.method === 'EDIT' &&
                this.supplierService.supplierBasedata.updatable
            ) {
                this.titleButtons.push({
                    iconname: 'archive',
                    function: 'supplierArchive',
                    styleclass: 'btn-primary',
                    tooltip: this.coreService.getMsgkey('mws.archive', undefined),
                });
            }
        } else if (action === 'EDIT') {
            this.titleButtons.push({
                iconname: 'circle-filled-left',
                function: 'hideEdit',
                styleclass: 'btn-primary',
                tooltip: this.coreService.getMsgkey('mws.back', undefined),
            });
            if (this.coreService.checkAbility('execute', 'supplier.archive') && this.supplierService.supplierBasedata.updatable) {
                this.titleButtons.push({
                    iconname: 'archive',
                    function: 'supplierArchive',
                    styleclass: 'btn-primary',
                    tooltip: this.coreService.getMsgkey('mws.archive', undefined),
                });
            }
            this.titleButtons.push({
                iconname: 'search',
                function: 'showPass',
                styleclass: 'btn-primary-light',
                tooltip: this.coreService.getMsgkey('mws.showpass', undefined),
            });
        }
    }

    public openCreateStepsModal() {
        this.actionNewCostcenterId = undefined;

        const options: NgbModalOptions = { centered: true, backdrop: 'static', size: 'lg' };
        this.modalService.openModal(this.createStepsModal(), options);
    }

    public selectCostcenter(costcenter: ICostcenter) {
        this.costcentertreeService.resetCostcenterChecked(this.costcentertreeService.costcenterTreeNodes[0]);
        const c = this.costcentertreeService.findCostcenterById(this.costcentertreeService.costcenterTree, costcenter.id);
        c.selected = true;
        // neue Kostenstellen ID setzen
        this.actionNewCostcenterId = costcenter.id;
    }

    // openCostcenterModal() {
    //     this.modalService.openModal(this.costCenterModalBasic);
    // }

    // cancelCostcenter(event) {
    //     this.router.navigate(['mwsp/supplier/overview']);
    // }

    // openNewSupplierModal() {
    //     const options: NgbModalOptions = {centered: true, backdrop: 'static'};
    //     this.modalService.openModal(this.newSupplierModal, options);
    //
    // }

    // checkCostcenter(event: any) {
    //     this.tempCostcenterId = event.id;
    //     this.modalService.closeAllModals();
    //     //
    //     this.openNewSupplierModal();
    // }

    public checkContractStatusValid() {
        // TODO
        if (this.supplierService.supplierBasedata.supplierStatus && this.supplierService.supplierBasedata.supplierStatus.length > 0) {
            this.isContractStatusValid =
                !this.supplierService.supplierBasedata.supplierStatus.find((ss) => ss.status.isComplete) &&
                !this.supplierService.supplierBasedata.supplierStatus.find((ss) => ss.status.isUncomplete);
        } else {
            this.isContractStatusValid = false;
        }
    }

    public toggleEditMode() {
        this.supplierService.method = 'EDIT';
        this.showPassDiv = false;
        document.getElementById('supplierDetailWrapper').classList.add('edit--mode');
        this.setTitleButtons('EDIT');
        this.actualSupplierContractCostcenterCustomer = undefined;
    }

    public showPass() {
        this.offcanvas().showPass();
        this.supplierService.method = 'EDIT';
        this.showPassDiv = false;
        // document.getElementById('supplierPassWrapper').classList.add('is--visible');
        document.getElementById('supplierDetailWrapper').classList.add('pass--shown');
    }

    public hidePass() {
        this.supplierService.method = 'EDIT';
        this.showPassDiv = false;
        // document.getElementById('supplierPassWrapper').classList.remove('is--visible');
        document.getElementById('supplierDetailWrapper').classList.remove('pass--shown');
    }

    public hideEdit() {
        if (this.supplierService.method === 'EDIT') {
            this.showPassDiv = true;
            this.initActiveSupplier();
            this.setTitleButtons('PASS');
        } else {
            this.router.navigate(['mwsp/supplier/overview']);
        }
    }

    public closeSupplerCreateModal() {
        this.modalService.closeAllModals();
        this.router.navigate(['mwsp/supplier/overview']);
    }

    public archiveSupplier() {
        this.supplierService
            .archiveSupplier(this.supplierService.supplierId)
            .pipe(take(1))
            .subscribe(
                (OK) => {
                    if (
                        this.supplierService.supplierBasedata &&
                        this.supplierService.supplierBasedata.supplierStatus &&
                        this.supplierService.supplierBasedata.supplierStatus.length > 0 &&
                        this.supplierService.supplierBasedata.supplierStatus.findIndex((ss) => ss.status.isArchived) >= 0
                    ) {
                        //
                        this.appService.showToast(
                            'success',
                            '',
                            this.coreService.getMsgkey('mws.supplier.activated.success', [this.supplierService.supplierBasedata.name]),
                        );
                    } else {
                        this.appService.showToast(
                            'success',
                            '',
                            this.coreService.getMsgkey('mws.supplier.archived.success', [this.supplierService.supplierBasedata.name]),
                        );
                    }
                    this.initActiveSupplier();
                },
                (err: IError) => {
                    this.utilityHelperService.handleComponentError(err);
                },
            );
    }

    public submitSupplier() {
        // PRÜFEN OB FORM VALID IST !!! NICHT VIA this.xxxxxxForm.valid
        // PRÜFEN OB FORM VALID IST !!! NICHT VIA this.xxxxxxForm.valid
        const result = this.ocJsonSchemaValidatorAjv.validateData('supplier', this.basedataForm.value);
        if (result.isValid) {
            this.loadingOverlayService.startLoading();
            this.supplierService
                .saveSupplierByName(this.basedataForm.get('name').value, this.actionNewCostcenterId)
                .pipe(take(1))
                .subscribe(
                    (data) => {
                        this.modalService.closeAllModals();
                        this.loadingOverlayService.stopLoading();
                    },
                    (err: IError) => {
                        this.utilityHelperService.handleComponentError(err);
                    },
                );
        }
    }

    public backToOverview() {
        this.initActiveSupplier();
        this.router.navigate(['mwsp/supplier/overview']);
    }

    public initFormValues() {
        if (this.supplierService.method === 'NEW') {
            this.basedataForm = this.formBuilder.group({
                // name: ['', [
                //     Validators.required,
                //     Validators.minLength(4),
                //     Validators.pattern('^[a-zA-Z ]*$')]],
                isRegional: [
                    {
                        value: false,
                        disabled: !this.coreService.checkAbility('create', 'supplier.isregional'),
                    },
                ],
                name: [
                    {
                        value: undefined,
                        disabled: !this.coreService.checkAbility('create', 'supplier.name'),
                    },
                    [
                        ocValidator(
                            this.ocJsonSchemaValidatorAjv,
                            this.environmentService,
                            'supplier',
                            'name',
                            this.coreService.getMsgkey('mws.suppliername', undefined),
                        ),
                    ],
                ],
                changed: false,
            });
            this.basedataForm.valueChanges.pipe(untilDestroyed(this)).subscribe((change) => {
                // PRÜFEN OB FORM VALID IST !!! NICHT VIA this.xxxxxxForm.valid
                // PRÜFEN OB FORM VALID IST !!! NICHT VIA this.xxxxxxForm.valid
                const result = this.ocJsonSchemaValidatorAjv.validateData('supplier', this.basedataForm.value);
                if (result.isValid) this.basedataForm.get('changed').markAsTouched();
                else this.basedataForm.get('changed').markAsUntouched();
            });
        }
    }

    /**
     *  wird ausgelöst wenn auf der CONTRACT-Tabelle eine Vereinbarung ausgewählt wird
     */
    public selectContract(contract: ISupplierContract) {
        this.isCustomerSelected = false;
        this.supplierService.supplierContract = contract;
        this.supplierService.supplierContract.id = contract.id;
        this.supplierContractCostcenterCustomers = contract.supplierContractCostcenterCustomers;
        this.supplierService
            .getContractDetailByContractId(contract.id)
            .pipe(take(1))
            .subscribe(
                (response) => {
                    // filled:  this.supplierService.supplierContractDetail
                    if (this.supplierContractCostcenterCustomers && this.supplierContractCostcenterCustomers.length > 0) {
                        this.supplierContractCostcenterCustomers.forEach((sccc) => {
                            const scc = this.supplierService.supplierContractDetail.supplierContractCostcenters.find(
                                (_scc) => _scc.id === sccc.supplierContractCostcenterId,
                            );
                            const costcenter = this.costcentertreeService.findCostcenterById(this.environmentService.userCostcenterTree, scc.costcenterId);
                            sccc['_supplierContractCostcenterNumber'] = costcenter.costcenterNumber;
                            sccc['_supplierContractCostcenterDescription'] = costcenter.description;
                            sccc['_supplierContractCostcenterId'] = costcenter.id;
                        });
                        //

                        // NEU SR: 20.12.2021
                        this.myCostcenterCustomerList = [];
                        this.supplierService.supplierContractDetail.supplierContractCostcenters.forEach((sCC) => {
                            const costcenter = this.costcentertreeService.findCostcenterById(this.environmentService.userCostcenterTree, sCC.costcenterId);
                            if (sCC.supplierContractCostcenterCustomers && sCC.supplierContractCostcenterCustomers.length > 0) {
                                sCC.supplierContractCostcenterCustomers.forEach((sCCC) => {
                                    // wg. Pass-Anzeige
                                    sCCC['_supplierContractCostcenterNumber'] = costcenter.costcenterNumber;
                                    sCCC['_supplierContractCostcenterDescription'] = costcenter.description;
                                    sCCC['_supplierContractCostcenterId'] = costcenter.id;
                                    // siehe http://gitlab.orgacard.local:8090/angular/apps/wawi/-/issues/975
                                    // Problem: Wenn ein Lieferant abgelaufene und aktive Verträge hat. Das bedeutet diese Kostenstelle hat ggf. abgelaufene, als auch gültige Verträge.
                                    // Problem: In this.supplierService.supplierBasedata.supplierStatus fehlt der Bezug zum Contract!
                                    let supplStatus = this.supplierService.supplierBasedata.supplierStatus.find(
                                        (ss) => ss.costcenterId === sCCC['_supplierContractCostcenterId'] && ss.status.isEnabled,
                                    );
                                    if (!supplStatus) {
                                        supplStatus = this.supplierService.supplierBasedata.supplierStatus.find(
                                            (ss) => ss.costcenterId === sCCC['_supplierContractCostcenterId'],
                                        );
                                    }
                                    //
                                    const myCostcenterCustomer = {
                                        costcenterId: sCC.costcenterId,
                                        costcenterNumber: costcenter ? costcenter.costcenterNumber : '',
                                        costcenterDescription: costcenter ? costcenter.description : '',
                                        customerId: sCCC.supplierCustomer.id,
                                        customerName: sCCC.supplierCustomer.customerName,
                                        customerNumber: sCCC.supplierCustomer.customerNumber,
                                        supplierContractCostcenterCustomer: sCCC,
                                        supplierContractCostcenterStatus: supplStatus,
                                    };
                                    this.myCostcenterCustomerList.push(myCostcenterCustomer);
                                });
                            } else {
                                const myCostcenterCustomer = {
                                    costcenterId: sCC.costcenterId,
                                    costcenterNumber: costcenter ? costcenter.costcenterNumber : '',
                                    costcenterDescription: costcenter ? costcenter.description : '',
                                    customerId: null,
                                    customerName: '',
                                    customerNumber: '',
                                    supplierContractCostcenterCustomer: undefined,
                                    supplierContractCostcenterStatus: this.supplierService.supplierBasedata.supplierStatus.find(
                                        (ss) => ss.costcenterId === sCC.costcenterId,
                                    ),
                                    // {
                                    //     descr: '', isArchived: false, isComplete: false, isEnabled: false, isUncomplete: true,
                                    //     costcenterId: undefined,
                                    //     id: undefined,
                                    //     status: {
                                    //         descr: '',
                                    //         isUncomplete: true,
                                    //         isComplete: false,
                                    //         isEnabled: false,
                                    //         isArchived: false
                                    //     }
                                    // }
                                };
                                this.myCostcenterCustomerList.push(myCostcenterCustomer);
                            }
                        });
                    }
                    this.supplierContractCostcenterStatus = undefined;
                    // NEU SR 15.12.2020
                    // this.supplierContractCostcenterStatus = this.supplierService.supplierBasedata.supplierStatus.find( ss => ss.costcenterId === contract.costcenterId );
                    // if (contract.costcentersAssigned && contract.costcentersAssigned.length>0) {
                    //     this.supplierContractCostcenterStatus = undefined;
                    //     contract.costcentersAssigned.forEach( costcenterId => {
                    //         this.supplierContractCostcenterStatus = this.supplierService.supplierBasedata.supplierStatus.find( ss => ss.costcenterId === costcenterId );
                    //     })
                    // }

                    this.actualCostcenterInfo = this.supplierService.supplierContract._costcenterNumber;
                    this.actualSupplierContractCostcenterCustomer = undefined;
                },
                (err: IError) => {
                    this.utilityHelperService.handleComponentError(err);
                },
            );
        //
        this.supplierService.updateCustomerListener(undefined);
    }

    /**
     *  wird ausgelöst wenn auf der CUSTOMER-Tabelle LINKS ein Kunde ausgewählt wird
     */
    public selectCustomer(supplierContractCostcenterCustomer: ISupplierContractCostcenterCustomer) {
        this.actualSupplierContractCostcenterCustomer = undefined;
        this.isCustomerSelected = true;
        if (supplierContractCostcenterCustomer) {
            this.supplierService.updateCustomerListener(supplierContractCostcenterCustomer.supplierCustomer);
            // get Customer deliveryterms -> this.supplierService.supplierContractCostcenterCustomerDetails?.supplierDeliveryTerms
            this.supplierService
                .getCustomerDetailsByCustomerId(supplierContractCostcenterCustomer.supplierCustomer.id)
                .pipe(take(1))
                .subscribe(
                    (supplierCustomerDetails: ISupplierCustomerDetails) => {
                        // NOTE: Strukturumstellung supplierDeliveryTerm ist weggefallen
                        // this.supplierService.getSupplierDeliveryTerms().subscribe(response => {
                        //     //
                        //     this.loadingOverlayService.stopLoading();
                        // }, (err: IError) => {
                        //     this.loadingOverlayService.stopLoading();
                        //     this.utilityHelperService.handleComponentError(err);
                        // });
                        this.supplierContractCostcenterStatus = this.supplierService.supplierBasedata.supplierStatus.find(
                            (ss) => ss.costcenterId === supplierContractCostcenterCustomer['_supplierContractCostcenterId'],
                        );
                        // const costcenter = this.costcentertreeService.findCostcenterById(this.environmentService.userCostcenterTree, supplierContractCostcenterCustomer.supplierContractCostcenterId);
                        this.actualCostcenterInfo = supplierContractCostcenterCustomer['_supplierContractCostcenterNumber'];
                        this.actualSupplierContractCostcenterCustomer = supplierContractCostcenterCustomer;
                    },
                    (err: IError) => {
                        this.utilityHelperService.handleComponentError(err);
                    },
                );
        } else {
            // dann STATUS: UNVOLLSTÄNDIG !!!
            this.supplierContractCostcenterStatus = {
                descr: '',
                isArchived: false,
                isComplete: false,
                isEnabled: false,
                isUncomplete: true,
                costcenterId: undefined,
                id: undefined,
                status: {
                    descr: '',
                    isUncomplete: true,
                    isComplete: false,
                    isEnabled: false,
                    isArchived: false,
                },
            };
        }
    }

    public cardButtonClick(button: IButtonTitelbarCard) {
        switch (button.function) {
            case 'toggleEdit':
                this.toggleEditMode();
                break;
            case 'showStatistics':
                break;
            case 'hideEdit':
                this.hideEdit();
                break;
            case 'supplierArchive':
                this.archiveSupplier();
                break;
            case 'backToOverview':
                this.backToOverview();
                break;
            case 'showPass':
                this.showPass();
                break;
        }
    }

    public nextStep() {
        this.step++;
    }

    public previousStep() {
        this.step--;
    }

    public isBasedataValid() {
        const resultSupplier = this.ocJsonSchemaValidatorAjv.validateData('supplier', this.supplierService.supplierBasedata);
        let resultAddress;
        if (this.supplierService.supplierBasedata.mainAddress && this.supplierService.supplierBasedata.mainAddress.address) {
            resultAddress = this.ocJsonSchemaValidatorAjv.validateData('address', this.supplierService.supplierBasedata.mainAddress.address);
        }
        if (resultSupplier.isValid && resultAddress && resultAddress.isValid) {
            return true;
        }
        return false;
    }
}
